import { NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PaginatorState } from 'primeng/paginator';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { Button } from '../../../Components/button/button';
import { CustomInput } from '../../../Components/input/custom-input';
import { SpinnerOverlayService } from '../../../Components/spinner/spinner-overlay.service';
import { ITEMS_PER_PAGE } from '../../../core/config/pagination.constants';
import { MessageService } from '../../../shared/message.service';
import { ColorUpdateComponent } from '../color-update/color-update.component';
import { IColor } from './color.model';
import { ColorService } from './color.service';
import {ColorDeleteComponent} from '../color-delete/color-delete.component';

@Component({
  selector: 'app-color',
  imports: [
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    CustomInput,
    Button,
    NgClass
  ],
  templateUrl: './color.component.html',
  styleUrl: './color.component.css'
})
export class Color implements OnInit {
  colorList: IColor[] = []

  messageService = inject(MessageService);

  totalItems: number = 0
  first = 0;
  rows = ITEMS_PER_PAGE;
  page = 0;
  sortField = 'id';
  sortOrder = 0;
  color: string | null = null
  lastEvent: any;

  constructor(
    private colorService: ColorService,
    private spinner: SpinnerOverlayService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.findAll()
  }

  findAll(reset: boolean = false) {
    this.handleLoading(true)

    if (reset) {
      this.sortField = "id"
      this.sortOrder = 0
    }

    const params = {
      page: reset ? 0 : this.page,
      size: this.rows,
      sort: `${this.sortField},${this.sortOrder === 1 ? 'asc' : 'desc'}`,
      name: this.color
    };

    this.colorService.findByParams(params).subscribe({
      next: (response) => {
        this.colorList = response.body?.colors?.colorList ?? []
        this.totalItems = response.body?.colors?.totalCount ?? 0
        this.handleLoading(false)
      },
      error: () => {
        this.handleLoading(false)
      }
    })
  }

  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

  loadColors(event: TableLazyLoadEvent) {
    if (JSON.stringify(event) === JSON.stringify(this.lastEvent)) {
      return;
    }
    this.lastEvent = event;

    this.sortField = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField ?? 'startDate';
    this.sortOrder = event.sortOrder ?? 1;
    this.page = Math.floor((event.first ?? 0) / (event.rows ?? 10));
    this.rows = event.rows ?? 10;

    this.findAll();
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? 10;
    this.page = Math.floor((this.first ?? 0) / (this.rows ?? 10));
    this.findAll(true);
  }

  getBackgroundClasses(active: boolean) {
    if (active) return 'bg-green-100 text-green-700';
    return 'bg-red-100 text-red-700';
  }

  openEditModal(id: number | null) {
    const dialogRef = this.dialog.open(ColorUpdateComponent, {
      width: '90%',
      height: 'auto',
      data: id ? {
        id: id
      } : null,
      panelClass: 'lexend-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.findAll(true)
        this.messageService.showSuccess("Producto actualizado con exito")
      }
    });
  }

  openActivateColorModal(name: string, id: number, active: boolean = false) {
    const dialogRef = this.dialog.open(ColorDeleteComponent, {

      data: {
        name: name,
        active: active
      },
      panelClass: 'lexend-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.activeOrInactiveUser(id, active)
      }
    });
  }

  activeOrInactiveUser(id: number, active: boolean) {
    this.handleLoading(true)
    this.colorService.activate(active, id).subscribe({
      next: () => {
        this.findAll()
        const message = active ? "activado" : "desactivado"
        this.messageService.showSuccess(`Diseño ${message} con exito`)
        this.handleLoading(false)
      },
      error: () => {
        this.handleLoading(false)
      }
    })
  }

  cleanFilter() {
    this.color = null;
    this.findAll(true);
  }
}
